import type { FC } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'

/** Public layout: header, page content and footer. */
export const Layout: FC<LayoutProps> = ({ children }) => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only z-50 rounded-lg bg-primary px-4 py-2 text-primary-foreground focus:not-sr-only focus:fixed focus:top-3 focus:left-3'
            >
                Skip to content
            </a>
            <Header />
            <main id='main' className='flex-1'>
                {children}
            </main>
            <Footer />
        </div>
    )
}
